import React from "react";
import { Sparkles } from "lucide-react";
import { Bubba } from "@/lib/Bubba";

export default function Login() {
  const login = () => {
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-screen bg-[#F5F0E8] relative overflow-hidden flex items-center justify-center px-6">
      <div className="absolute inset-0" style={{ background: "radial-gradient(600px circle at 50% 30%, rgba(16,185,129,0.15), transparent)" }} />
      <div className="relative z-10 w-full max-w-md flex flex-col items-center text-center">
        <Bubba mood="Cheering" size={200} />
        <div className="mt-3 flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#E3D9C8]">
          <Sparkles size={14} className="text-[#FCD34D]" />
          <span className="text-xs font-semibold text-slate-500">Your health buddy is here</span>
        </div>
        <h1 className="mt-4 text-6xl font-extrabold text-slate-900 tracking-tight">STILL</h1>
        <p className="mt-3 text-slate-500 text-base leading-relaxed max-w-sm">
          Track food, meds & fasting with Bubba — the AI companion that celebrates every win, zero guilt.
        </p>
        <button data-testid="auth-login-button" onClick={login}
          className="mt-10 w-full flex items-center justify-center gap-3 bg-[#651F33] hover:bg-[#521829] transition-colors text-[#F5F0E8] font-bold text-base py-4 rounded-full">
          <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#F5F0E8" d="M21.35 11.1h-9.17v2.73h6.5c-.28 1.5-1.15 2.78-2.44 3.63v3h3.95c2.31-2.13 3.64-5.27 3.64-9 0-.6-.05-1.18-.15-1.74z"/><path fill="#F5F0E8" d="M12.18 22c2.43 0 4.47-.8 5.96-2.18l-3.95-3c-.9.6-2.05.96-3.34.96-2.57 0-4.75-1.73-5.53-4.06H1.26v3.1C2.74 19.76 6.19 22 12.18 22z"/><path fill="#F5F0E8" d="M6.65 13.72c-.2-.6-.31-1.24-.31-1.9s.11-1.3.31-1.9V6.82H1.26C.46 8.4 0 10.15 0 12s.46 3.6 1.26 5.18l5.39-3.46z"/><path fill="#F5F0E8" d="M12.18 4.75c1.32 0 2.5.46 3.44 1.35l3.5-3.5C17.02 1.19 14.98 0 12.18 0 6.19 0 2.74 2.24 1.26 6.82l5.39 3.1c.78-2.33 2.96-4.06 5.53-4.06z"/></svg>
          Continue with Google
        </button>
        <p className="mt-3 text-[11px] text-slate-400">By continuing you agree to our Terms & Privacy Policy.</p>
      </div>
    </div>
  );
}
